import { createSlice } from '@reduxjs/toolkit';

export interface ErrorMessageState {
  message: string;
}

const initialState: ErrorMessageState = {
  message: ''
};

const snackBarSlice = createSlice({
  name: 'errorMessage',
  initialState,
  reducers: {
    setSnackbarMessage(state, action) {
      state.message = action.payload;
    },
    resetSnackBar() {
      return initialState;
    }
  }
});

export const { setSnackbarMessage, resetSnackBar } = snackBarSlice.actions;
export default snackBarSlice.reducer;
